export const NOTIFICATION_WHERE_CONDITION = `{  NOT: [
    { initiator: { deactivated: { equals: true } } }
    { relatedArticle: { deactivated: { equals: true } } }
    { relatedComment: { deactivated: { equals: true } } }
  ], recipient: { id: { equals: $recipientId } } }`;
